import { IReclassesAndAdjustmentExtension } from '@modeso/types__aumico-lib-annualreport-be';

export interface IItemForCalculatingRatioOption extends IReclassesAndAdjustmentExtension {
    name: string;
    caption: string;
    calculatedClosingBalance: number;
    calculatedOpeningBalance: number;
    openingAdjustment: number;
    closingAdjustment: number;
    openingReClass: number;
    closingReClass: number;
}
